import React, { useEffect, useState } from 'react'
import ParamsPopUp from '../Params-Info-popup'
import SystemPromptModal from 'components/SystemPromptModal';
import { Controller, useFormContext } from 'react-hook-form';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import * as myconst from "../../../constants/index"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { datatableView, datatableViewHover, infoIcon } from 'assets/icons';
import { InputTextarea } from 'primereact/inputtextarea';
import ReactMarkdown from 'react-markdown';
import { Dropdown } from 'primereact/dropdown';

const GenerationParams = ({ methods,
    fieldData,
    clientVersion,
    isGenerationDataChanged,
    setIsGenerationChanged,
    handelPrompt,
    textValue,
    setTextValue
}
    : any) => {
    const { register, setValue, formState: { errors }, watch, getValues } = useFormContext()
    const [modalContent, setModalContent] = useState('');
    const [visible, setVisible] = useState<boolean>(false);
    const [showSystemPromptModal, setShowSystemPromptModal] = useState<boolean>(false);
    const [label, setLabel] = useState("");
    const [values, setValues] = useState("");
    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [prompt, setPrompt] = useState("");
    const [test, setTest] = useState("");
    const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
    const [is_hover_eye, setIs_hover_eye] = useState<string>("");
    const [rangeValue, setRangeValue] = useState(getValues("faiss_vactor_db.source_info_threshold"));

    const handleCloseSystemPrompt = () => {
        setShowSystemPromptModal(false)
        setVisible(false);
    }
    const handelPrompt2 = (raw: any) => {
        setValue(values, raw)
    }
    const Generationfeilds = myconst.Generationfeilds
    const updateTooltipPosition = (event: any, maxValue: number) => {
        const sliderWidth = event.target.offsetWidth;
        const sliderValue = parseFloat(event.target.value);
        const thumbWidth = 14; // Adjust according to your slider thumb size
        const tooltipWidth = 40; // Adjust according to your tooltip width
        const offsetLeft = ((sliderValue / maxValue) * (sliderWidth - thumbWidth) + (thumbWidth / 2) - (tooltipWidth / 2)) + 20;
        const offsetTop = -30; // Adjust top position as needed
        setTooltipPosition({ left: offsetLeft, top: offsetTop });
    };
    const dropdownOptions: { [key: string]: { name: number | boolean | string }[] } = {
        'generation_param.max_new_tokens': [{ name: 256 }, { name: 512 }, { name: 1000 }],
        // 'generation_param.max_new_tokens': [{ name: 256 }, { name: 512 }, { name: 1024 }, { name: 2048 }],
    };
    const returnLength = (text: any) => {
        return text?.map((str: string) => str.split('')).reduce((acc: string, val: string) => acc.concat(val), [])?.length
    }
    const RemoveAsterisks = (text: string) => {
        // Regular expression to match asterisks, double asterisks, and triple asterisks
        const regex = /\*{1,3}/g;

        // Replace all occurrences of asterisks, double asterisks, and triple asterisks with an empty string
        const updatedText = text?.replace(regex, '');

        return updatedText;
    };
    const sliceMarkdown = (text: string, visibleLimit: number = 150) => {
        let visibleCount = 0;
        let i = 0;
        let result = '';
        const stack: string[] = [];

        const isMarkdownToken = (str: string): '***' | '**' | '*' | null => {
            if (str.startsWith('***')) return '***';
            if (str.startsWith('**')) return '**';
            if (str.startsWith('*')) return '*';
            return null;
        };

        while (i < text.length && visibleCount < visibleLimit) {
            const token = isMarkdownToken(text.slice(i));
            if (token) {
                result += token;

                // Balance markdown: open/close tracking
                if (stack[stack.length - 1] === token) {
                    stack.pop(); // closing tag
                } else {
                    stack.push(token); // opening tag
                }

                i += token.length;
            } else {
                result += text[i];
                visibleCount++;
                i++;
            }
        }

        // Finish unclosed tags
        while (stack.length) {
            result += stack.pop();
        }

        return result;
    };
    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value
        let _filters = { ...filters }

        _filters["global"]!.value = value

        setFilters(_filters)
        setGlobalFilterValue(value)
    }
    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        })
        setGlobalFilterValue("")
    }

    useEffect(() => {
        // setValues(fieldData)
        watch(
            (values) => {
                const changed = Object.keys(values).some((key) => {
                    const originalValue = fieldData[key];
                    const currentValue = values[key];
                    return JSON.stringify(originalValue) !== JSON.stringify(currentValue);
                });
                setIsGenerationChanged(changed);
            },
            { nested: true }
        );

    }, [watch])


    const getErrorMessage = (errorKey: string): string => {
        const nestedKeys = errorKey.split('.');
        let currentError: any = errors;

        for (const key of nestedKeys) {
            if (currentError && typeof currentError === 'object' && key in currentError) {
                currentError = currentError[key];
            } else {
                return '';
            }
        }
        return currentError?.message || '';
    };
    const getMinValueForRow = (key: any) => {
        switch (key) {
            case 'generation_param.max_token':
                return 128;
            case 'generation_param.temperature':
                return 0;
            default:
                return 0;
        }
    };
    const getMaxValueForRow = (key: any) => {
        switch (key) {
            case 'generation_param.max_token':
                return 1000;
            case 'generation_param.temperature':
                return 2;
            default:
                return Infinity;
        }
    };
    const handleSystemPrompt = (e: any, data: any) => {
        // default_system_prompt: fieldData?.generation_param?.default_system_prompt,
        setValues(data.key);
        setLabel(data.label);
        const key = data.key.split(".")[1];
        if (key === "default_email_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_email_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_system_prompt));
        } else if (key === "default_article_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_article_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_article_template));
        } else if (key === "default_regenerate_product_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_regenerate_product_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_regenerate_product_template));
        } else if (key === "default_product_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_product_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_product_template));
        } else if (key === "default_post_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_post_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_post_template));
        } else if (key === "default_idea_template") {
            setPrompt(JSON.stringify(getValues("generation_param.default_idea_template")));
            // setPrompt(JSON.stringify(fieldData?.generation_param.default_idea_template));
        }
        setTest(data);
        e.preventDefault()
        setShowSystemPromptModal(true)
    }
    const modals = [
        "Email Prompt",
        "Post Prompt",
        "Product Prompt",
        "Regenerate Product Prompt",
        "Article Prompt",
        "Idea Prompt"
    ]
    const handleChange = (event: any, maxValue: number) => {
        if (event.target.value > rangeValue && maxValue === 2) {
            setTextValue("With each increase in the threshold, Source Info's output will become less accurate, resulting in fewer relevant documents being retrieved.")
            setRangeValue(event.target.value); // Update rangeValue state when slider value changes
        } else if (event.target.value < rangeValue && maxValue === 2) {
            setTextValue("By lowering the threshold, Source Info's output will become more accurate, resulting in more relevant documents being retrieved.")
            setRangeValue(event.target.value); // Update rangeValue state when slider value changes
        }
        updateTooltipPosition(event, maxValue); // Update tooltip position
    };
    useEffect(() => {
        initFilters()
    }, [])
    return (
        <>
            <div className="datatable-wrapper">
                <div className="w-full mb-3">
                    <IconField iconPosition="right" className='user-input'>
                        <InputIcon className="pi pi-search"> </InputIcon>
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Search by parameter"
                            className='search-bar-input w-full'
                            onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </IconField>
                </div>
                <DataTable
                    filters={filters}
                    globalFilterFields={["label"]}
                    showGridlines
                    value={Generationfeilds}
                    emptyMessage="No fields found."
                    scrollable={true}
                    scrollHeight='410px'
                >
                    <Column
                        header="Category"
                        field="category"
                        style={{ minWidth: '100px' }}
                    />
                    <Column
                        field="label"
                        header="Parameter"
                        style={{ minWidth: '300px' }}
                        sortable
                        body={(rowData: any, options: { rowIndex: number }) => {
                            const targetId = `tooltip-${options.rowIndex}`;
                            return (
                                <><span className="header-tooltip">
                                    <span className={`tooltip-target-${options.rowIndex}`}>
                                        {rowData.label}
                                        <span className="mr-2" style={{ color: "#FF5155" }}>*</span>
                                        <i
                                            data-bs-toggle="modal"
                                            data-bs-target="#Params-Info"
                                            onClick={() => setModalContent(rowData.toolTipInfo)}
                                            style={{ cursor: "pointer" }}
                                        >
                                            <img src={infoIcon} alt='info-icon' />
                                        </i>
                                        {/* <Tooltip target={`#${targetId}`} content={rowData.header} position="top" /> */}
                                    </span>
                                </span>
                                </>
                            );
                        }}
                    >
                    </Column>
                    <Column
                        header="Field 1"
                        field='field1'
                        style={{ minWidth: '150px' }}
                    />
                    <Column
                        header="Field 2"
                        field='field2'
                        style={{ minWidth: '150px' }}
                    />
                    <Column
                        header="Value"
                        style={{ minWidth: '600px' }}
                        body={(rowData, index) => (
                            <>
                                {
                                    (rowData.type !== "text_area" && rowData.type !== "dropdown" && rowData.type !== "slider") ?
                                        (<>
                                            <Controller
                                                name={rowData.key}
                                                control={methods.control}
                                                rules={{
                                                    required: `${rowData.label} is required`,
                                                    ...(rowData.type === "number" && {
                                                        min: {
                                                            value: getMinValueForRow(rowData.key),
                                                            message: `Value must be minimum ${getMinValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
                                                        },
                                                        max: {
                                                            value: getMaxValueForRow(rowData.key),
                                                            message: `Value must be minimum ${getMaxValueForRow(rowData.key)} to maximum ${getMaxValueForRow(rowData.key)}`,
                                                        },
                                                    }),
                                                    ...(rowData.key === "actual_pdf.actual_pdf_base_url" && {
                                                        pattern: {
                                                            value: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
                                                            message: "Enter a valid URL",
                                                        },
                                                    }),
                                                    ...(rowData.key === "faiss_vector_db.ron_main_vector_db_directory" && {
                                                        pattern: {
                                                            value: /^\/[\w\-./]*$/,
                                                            message: "Enter correct path",
                                                        },
                                                    }),
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <div className="param-tab-form">
                                                            <div className='form-row'>
                                                                <div className='form-col'>
                                                                    <InputText
                                                                        className="w-full"
                                                                        disabled={clientVersion !== "" ? true : false || rowData.key === "lama_model_name.model_name_or_path" || rowData.key === "lama_model_name.model_basename" || rowData.key === "embedding_model_name.embedding_model_name" || rowData.key === "Metadata.version"}
                                                                        type={rowData.type}
                                                                        placeholder={
                                                                            rowData.type === "number" ?
                                                                                (isFinite(getMinValueForRow(rowData.key)) && isFinite(getMaxValueForRow(rowData.key))) ?
                                                                                    `Enter Number (${getMinValueForRow(rowData.key)} - ${getMaxValueForRow(rowData.key)})` :
                                                                                    "Enter Number"
                                                                                :
                                                                                rowData.type === "password"
                                                                                    ? "Enter your password"
                                                                                    : "Enter your Text here"
                                                                        }
                                                                        {...field}
                                                                    />
                                                                    <p style={{ color: "#FF5155" }}>{getErrorMessage(rowData.key)}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        </>)
                                        : rowData.type === "dropdown" ? (
                                            <Controller
                                                name={rowData.key}
                                                control={methods.control}
                                                // defaultValue=""
                                                rules={{
                                                    required: `${rowData.field} is Required`,
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <div className="param-tab-form">
                                                            <div className='form-row'>
                                                                <div className='form-col'>
                                                                    <Dropdown
                                                                        {...field}
                                                                        options={dropdownOptions[rowData.key]}
                                                                        onChange={(e) => setValue(rowData.key, e.target.value, { shouldValidate: true })}
                                                                        placeholder="Select an option"
                                                                        value={field.value}
                                                                        optionLabel="name"
                                                                        disabled={clientVersion !== "" ? true : false}
                                                                        className={`w-100`}
                                                                    />
                                                                    <p style={{ color: "#FF5155" }}>{errors[`${rowData.field}`]?.message?.toString()}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            />
                                        )
                                            :
                                            rowData.type === "slider" ? (
                                                <Controller
                                                    name={rowData.key}
                                                    control={methods.control}
                                                    render={({ field: { onBlur, onChange, value } }) => (
                                                        <div className="w-full">
                                                            {/* <div className="d-flex justify-content-center fw-bold align-items-center">
                                                            <span style={{ fontSize: "large" }}>{field.value ? field.value : 0}</span>
                                                        </div> */}
                                                            {/* <div style={{ position: 'relative' }}> */}
                                                            {/* <div className="d-flex align-items-center"> */}
                                                            {/* <p className="mr-3">{0}</p> */}
                                                            {/* <Slider
                                                                {...field}
                                                                className="w-full"
                                                                onChange={(e: any) => {
                                                                    // setSlideValue(e.target.value);
                                                                    setValue(rowData.key, e.value, { shouldValidate: true });
                                                                }}
                                                                min={0}
                                                                max={rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}
                                                                step={0.1}
                                                                value={field.value}
                                                            /> */}
                                                            <div className="range-slider-container">
                                                                <div className="d-flex flex-column">
                                                                    <span>
                                                                        <input
                                                                            type="range"
                                                                            className="w-full"
                                                                            min={0} // Minimum value
                                                                            max={2} // Maximum value
                                                                            value={value} // Current value
                                                                            onChange={(e) => { handleChange(e, 2); onChange(e.target.value) }} // Handle change event
                                                                            onMouseOver={(e) => { updateTooltipPosition(e, 2); }}
                                                                            onMouseOut={() => setTooltipPosition({ left: 0, top: 0 })}
                                                                            step={0.1}
                                                                            disabled={clientVersion !== "" ? true : false}
                                                                        />
                                                                        {/* Tooltip to display current value */}
                                                                        {(value || value === 0) && tooltipPosition.top !== 0 && tooltipPosition.left !== 0 &&
                                                                            <span className="tooltip" style={{ left: tooltipPosition.left }}>
                                                                                {value}
                                                                            </span>
                                                                        }
                                                                    </span>
                                                                    <div className="d-flex justify-content-between">
                                                                        <span className="fw-bold">0</span>
                                                                        <span className="fw-bold">2</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {rowData.key === "faiss_vactor_db.source_info_threshold" &&
                                                                <span className="fw-medium">{textValue}</span>
                                                            }
                                                            {/* <p className="ml-3">{rowData.key === "faiss_vactor_db.source_info_threshold" ? 2 : 1}</p> */}
                                                            {/* </div> */}
                                                            {/* <div style={{ position: 'absolute', top: '-8px', left: '50%', transform: 'translateX(-50%)', fontWeight: "500" }}> */}

                                                            {/* <p className="text-danger">{getErrorMessage(rowData.key)}</p> */}
                                                        </div>
                                                    )}
                                                />

                                            )
                                                :
                                                modals.includes(rowData.label) ?
                                                    (
                                                        // <div className='d-flex'>
                                                        // 	<Button className='btn btn-primary  btn-sm px-3' data-bs-toggle="modal" data-bs-target="#active-deactive" onClick={(e) => {
                                                        // 		handleSystemPrompt(e, rowData)
                                                        // 	}}>Click here</Button>

                                                        // </div>
                                                        // data-bs-toggle={clientVersion === "" && "modal"} data-bs-target={clientVersion === "" && "#active-deactive"}
                                                        <span className="c-pointer" onClick={(e) => {
                                                            if (clientVersion === "") {
                                                                handleSystemPrompt(e, rowData)
                                                                setVisible(true);
                                                            }
                                                        }} >
                                                            <Controller
                                                                name={rowData.key}
                                                                control={methods.control}
                                                                render={({ field }) => (
                                                                    <>
                                                                        {/* <InputTextarea
																			{...field}
																			value={temp(field?.value) as any}
																			// value={JSON.parse(field?.value)}
																			// disabled={true}
																			// disabled={clientVersion !== "" ? true : false}
																			readOnly
																			rows={5}
																			cols={30}
																			className="w-full c-pointer"
																		/> */}
                                                                        {/* {console.log("field?.value", field?.value, field?.value?.length)} */}
                                                                        <div className="backend-textarea" style={{ cursor: clientVersion === "" ? "pointer" : "default", opacity: clientVersion === "" ? "1" : "0.7" }} >
                                                                            {/* <ReactMarkdown>{`${JSON.parse(field?.value).slice(0, 150)}...`}</ReactMarkdown> */}
                                                                            {/* {MarkdownRenderer(field?.value)} */}
                                                                            <ReactMarkdown>
                                                                                {`${sliceMarkdown(field?.value)}${RemoveAsterisks(field?.value)?.length > 150 ? "..." : ""}`}
                                                                                {/* {`${JSON.parse(JSON.stringify(field?.value)).slice(0, 150)}${field?.value?.length > 150 ? "..." : ""}`} */}
                                                                            </ReactMarkdown>
                                                                            <span className={`fw-bold c-pointer ${clientVersion === "" ? 'text-primary' : 'text-secondary'}`} style={{ cursor: clientVersion === "" ? "pointer" : "default" }}
                                                                            // onMouseEnter={() => setIs_hover_eye(rowData.website_id)} onMouseLeave={() => setIs_hover_eye("")}
                                                                            >
                                                                                <img src={is_hover_eye === rowData.website_id ? datatableViewHover : datatableView} alt='view-icon' />
                                                                            </span>
                                                                            {/* <span className="fw-bold d-flex flex-row-reverse text-primary">View more</span> */}
                                                                        </div>
                                                                        {/* <p className="text-danger">{errors[`${rowData.field}`]?.message?.toString()}</p> */}
                                                                    </>
                                                                )}
                                                            />
                                                            {/* <div>
													{markdown(rowData)}
												</div> */}
                                                        </span>
                                                    )
                                                    :
                                                    (
                                                        <>
                                                            <Controller
                                                                name={rowData.key}
                                                                control={methods.control}
                                                                defaultValue=""
                                                                rules={{
                                                                    required: `${rowData.field} is Required`,
                                                                }}
                                                                render={({ field }) => (
                                                                    <>
                                                                        <div className="param-tab-form">
                                                                            <div className='form-row'>
                                                                                <div className='form-col'>
                                                                                    <InputTextarea
                                                                                        {...field}
                                                                                        disabled={clientVersion !== "" ? true : false}
                                                                                        rows={5}
                                                                                        cols={30}
                                                                                        className="w-full "
                                                                                    />
                                                                                    <p style={{ color: "#FF5155" }}>{errors[`${rowData.field}`]?.message?.toString()}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            />
                                                        </>
                                                    )
                                    // (<>
                                    //     <Controller
                                    //         name={rowData.key}
                                    //         control={control}
                                    //         // defaultValue={null}
                                    //         rules={{ required: 'Please select a log source' }}
                                    //         render={({ field }) => (
                                    //             <Dropdown
                                    //                 id={rowData.key}
                                    //                 onChange={(e) => {
                                    //                     field.onChange(e.target.value)
                                    //                     setSelectedCity(e.target.value)
                                    //                 }}
                                    //                 value={field.value}
                                    //                 placeholder="Select Log source"
                                    //                 options={options}
                                    //                 className={`w-100  border-0`}
                                    //             />
                                    //         )}
                                    //     />
                                    //     <p className="text-danger">
                                    //         {errors[`${rowData.key}`]?.message?.toString()}
                                    //     </p>
                                    // </>)
                                }
                            </>
                        )}
                    />
                </DataTable>
            </div>
            <ParamsPopUp content={modalContent} />
            <SystemPromptModal setVisible={setVisible} visible={visible} showSystemPromptModal={showSystemPromptModal} handleCloseSystemPrompt={handleCloseSystemPrompt} label={label} prompt={prompt} handelPrompt={handelPrompt2} />
        </>
    )
}

export default GenerationParams